import { render, staticRenderFns } from "./Datagrid.vue?vue&type=template&id=4aa73f05"
import script from "./Datagrid.vue?vue&type=script&lang=ts"
export * from "./Datagrid.vue?vue&type=script&lang=ts"
import style0 from "./Datagrid.vue?vue&type=style&index=0&id=4aa73f05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports